import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyDuYfhPgVAez5DJjp27XAqY6kU9-6CRnf8",
  authDomain: "msp-montech.firebaseapp.com",
  projectId: "msp-montech",
  storageBucket: "msp-montech.appspot.com",
  messagingSenderId: "53272621495",
  appId: "1:53272621495:web:2513791d46595f50517832",
  measurementId: "G-GGPGK3BV02"
};

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

export { messaging, getToken, onMessage };
